var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start align-items-start mb-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "w-100",
                        attrs: { options: _vm.period },
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start align-items-start mb-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-center align-items-center",
                          attrs: { variant: "primary" },
                          on: { click: _vm.previewPayroll },
                        },
                        [_vm._v(" Preview ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start align-items-start mb-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-center align-items-center",
                          attrs: { variant: "primary" },
                          on: { click: _vm.processPayroll },
                        },
                        [_vm._v(" Process ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start align-items-start mb-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-center align-items-center",
                          attrs: { variant: "primary" },
                          on: { click: _vm.exportPayroll },
                        },
                        [_vm._v(" Export ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start align-items-start mb-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _vm.HasPermission(_vm.PermissionList.HRMS_Create)
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "w-100 d-flex justify-content-center align-items-center",
                              attrs: {
                                variant: "primary",
                                to: {
                                  path: "/hrmanagement/report",
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "View" },
                              }),
                              _vm._v(" Variance Report "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start align-items-start mb-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _vm.HasPermission(_vm.PermissionList.HRMS_Create)
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "d-none d-md-flex justify-content-end align-items-center",
                              attrs: {
                                variant: "primary",
                                to: {
                                  path: "/hrmanagement/Allocations/AddAllocation/add-allocation",
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Add Allocation "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.HasPermission(_vm.PermissionList.HRMS_Create)
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "d-flex d-md-none w-100 justify-content-center align-items-center",
                              attrs: {
                                variant: "primary",
                                to: {
                                  path: "/hrmanagement/Allocations/AddAllocation/add-allocation",
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Add Allocation "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "1" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-col", {
                    staticClass: "d-flex justify-content-end mb-2",
                    staticStyle: { position: "relative", "z-index": "1" },
                    attrs: { cols: "12" },
                  }),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredEmployees,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm.HasPermission(
                                      _vm.PermissionList.HRMS_View
                                    )
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: {
                                              to: {
                                                name: "payroll-view",
                                                params: {
                                                  id: data.item.id,
                                                  allocationDate: _vm.selected,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: { icon: "EyeIcon" },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "align-middle ml-50",
                                              },
                                              [_vm._v("View")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "b-modal",
                        {
                          ref: "editLeaveRequest",
                          attrs: {
                            id: "modal-edit-leave-request",
                            "ok-only": "",
                            "ok-title": "Edit",
                            centered: "",
                            size: "lg",
                            title: "Edit Leave Request",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("EditLeaveRequest", {
                            on: { refresh: _vm.refreshData },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }